module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/2_2c622d0bfa42fbbbb4b894f1279fe805.png";